import { useEffect, useState } from 'react'
import {Modal, ModalHeader, CustomText} from '@polichat/flamboyant'

import { Container, VariableItem } from './VariableModal.styles'
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function VariableModal({
  isOpen,
  onCloseRequest,
  variables,
  onUpdate
}) {
  const variablesTitle = useGlotaT('spa.messageBuilder.variables.title');
  const variablesDescription = useGlotaT('spa.messageBuilder.variables.description');

  const [variableData, setVariableData] = useState({
    search: '',
    variables,
  });
  const [filteredVariables, setFilteredVariables] = useState(variables);

  const handleCloseRequest = () => {
    // Reset search filter before closing modal
    setFilteredVariables(variableData.variables);
    onCloseRequest();
  }

  const handleInputChange = ({target: {name, value}}) => {
    setVariableData({
      ...variableData,
      [name]: value
    });
  }

  const handleSelectVariable = (selectedData) => {
    onUpdate(selectedData);
    handleCloseRequest();
  }

  useEffect(() => {
    const filteredVariables = variableData.variables.filter(variable => {
      return variable.label.toLowerCase().includes(variableData.search.toLowerCase());
    });
    setFilteredVariables(filteredVariables);
  }, [variableData.search])


  return (
    <Modal isOpen={isOpen} toggle={handleCloseRequest}>
      <ModalHeader toggle={handleCloseRequest}>{variablesTitle}</ModalHeader>
        <Container>
          <div>
            <p>{variablesDescription}</p>
            <CustomText
              type="text"
              id="variable-search"
              name="search"
              onChange={handleInputChange}
            />
          </div>
          <div>
            <ul>
              {filteredVariables.map(variable => (
                <VariableItem
                  key={variable.id}
                  onClick={() => handleSelectVariable(variable)}
                >
                  <span>{variable.label}</span>
                  <span>{variable.description}</span>
                </VariableItem>
              ))}
            </ul>
          </div>
        </Container>
    </Modal>
  );
}

export default VariableModal;
